<template>
	<ui-text type="textarea" :maxlength="maxlength" :show-word-limit="showWordLimit" :novalidate="novalidate" :overflowWidth="overflowWidth" :nomessage="nomessage" :value="value" @input="$emit('input',$event);" :required="required" :view="view" ref="control" />
</template>

<script>
export default {
	name:'ui-textarea',
	props:{
		value:{type:String,default:''},
		required:{type:Boolean,default:false},
		view:{type:Boolean,default:false},
		novalidate:{type:Boolean,default:false},
		nomessage:{type:Boolean,default:false},
		overflowWidth:{type:String,default:''},
		maxlength:{type:Number},
		showWordLimit:{type:Boolean,default:true},
	},
	data(){
		return {
			columns:Infinity
		};
	},
	created(){},
	methods:{
		validate(){
			return this.$refs.control.validate();
		},
		setTestValue(label){
			return this.$refs.control.setTestValue(label);
		},
		getMessage(){
			return this.$refs.control.getMessage();
		}
	}
}
</script>

<style scoped>
</style>